export default "__VITE_ASSET__ab42de29__"